import React from 'react';
import Meta from './Meta';

export default function Business() {
  const containerStyle = {
    maxWidth: 820,
    margin: '40px auto',
    padding: '20px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    color: '#222',
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    lineHeight: 1.6,
  };

  const titleStyle = {
    fontSize: '2.2rem',
    fontWeight: '700',
    marginBottom: '24px',
    color: '#004085',
    textAlign: 'center',
  };

  const quoteStyle = {
    fontStyle: 'italic',
    backgroundColor: '#e9ecef',
    padding: '15px 20px',
    borderLeft: '6px solid #007bff',
    marginBottom: '30px',
    fontSize: '1.1rem',
    color: '#343a40',
  };

  const authorStyle = {
    textAlign: 'right',
    fontWeight: '600',
    fontSize: '1rem',
    marginTop: '6px',
    color: '#495057',
  };

  const sectionStyle = {
    marginBottom: '28px',
  };

  const sectionTitleStyle = {
    fontSize: '1.3rem',
    fontWeight: '700',
    marginBottom: '12px',
    color: '#007bff',
  };

  const listStyle = {
    listStyleType: 'disc',
    paddingLeft: '20px',
    color: '#333',
  };

  const phoneStyle = {
    display: 'block',
    marginTop: '30px',
    padding: '15px',
    backgroundColor: '#007bff',
    color: '#fff',
    fontWeight: '700',
    fontSize: '1.2rem',
    textAlign: 'center',
    borderRadius: '8px',
    textDecoration: 'none',
    cursor: 'pointer',
    width: 'fit-content',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  return (
    <React.Fragment>
      <Meta
         title="Интернет для офиса и бизнеса в Москве и МО — подключение от «ИТ Особа»"
         description="Выделенный интернет для офиса с гарантией скорости. Подключим ваш бизнес в Московской области (Подольск, Домодедово, Видное, Быковка, Александровка, Чулпаново, Кучино и т.д)"
       />
    <div style={containerStyle}>
      <h1 style={titleStyle}>Интернет для юридических лиц</h1>

      <blockquote style={quoteStyle}>
        Новый фундаментальный закон бизнеса заключается в том, что Интернет меняет все. Интернет-технологии, по меньшей мере, меняют способы взаимодействия компаний – даже самых маленьких – со своими сотрудниками, партнерами и поставщиками.
        <div style={authorStyle}>&mdash; Билл Гейтс</div>
      </blockquote>

      <p>
        Вашим сотрудникам и клиентам нужен быстрый и надежный интернет? Мы решим этот вопрос без лишних затрат и потери вашего времени. С интернетом от "ИТ Особа" вы увеличите скорость и качество предоставляемых услуг, бизнес-процессов внутри компании. Мы предлагаем вам:
      </p>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Скорость и надежность</h2>
        <p>
          Интернет со скоростью до 1Гб/с обеспечивает быструю работу средств электронного документооборота, системы клиент-банк, платежных терминалов, мгновенную связь между отдельными офисами.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Сервис и оперативность</h2>
        <p>
          Наши специалисты осуществляют техподдержку 12 часов в сутки, ведут постоянный мониторинг подключения и устраняют неполадки в срок до 6 часов.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Полный спектр услуг</h2>
        <p>
          Мы проводим анализ, проектирование, установку, настройку сервисов для каждого клиента и предлагаем эффективные решения для вашего бизнеса.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Прозрачность ваших расходов</h2>
        <p>
          Получайте статистику, информацию о расходах, управляйте услугой в любое время и в любом месте в личном кабинете клиента ИТ Особа.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Индивидуальный подход</h2>
        <p>
          С вами работает персональный менеджер. Для вас мы обеспечиваем возможность резервирования электропитания и магистрального оператора.
        </p>
      </section>

      <a href="tel:+74994033148" style={phoneStyle}>
        Позвоните 8 (499) 403-31-48
      </a>
      <p style={{ textAlign: 'center', marginTop: '8px', color: '#555' }}>
        и мы сделаем вам индивидуальное предложение.
      </p>
    </div>
    </React.Fragment>
  );
}